/* eslint-disable react-hooks/exhaustive-deps */
import {
  AppBar,
  Avatar,
  Badge,
  Box,
  Button,
  CssBaseline,
  Dialog,
  DialogContent,
  DialogTitle,
  Drawer,
  Grid,
  IconButton,
  List,
  ListItem,
  Menu,
  MenuItem,
  Modal,
  styled,
  Toolbar,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import ChatRoundedIcon from "@mui/icons-material/ChatRounded";
import PersonIcon from "@mui/icons-material/Person";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { getUsersById } from "../../../services/api/apiManager";
import {
  CALL_PROVIDER_EVENT,
  changeCallProvider,
  getLocalCallProvider,
  syncCallProviderFromServer,
} from "../../../services/callProvider";
import AppLogo from "../../../../assets/icons/MaxChatsLogo.svg";
import LogoutIcon from "@mui/icons-material/Logout";
import { settings as s } from "../../../services/Settings";
import {
  getSignalRConnection,
  initializeSignalRConnection,
  LastSeenMessage,
  sendUserOnline,
  StopConnection,
} from "../../../services/signalRService/signalRService";
import {
  setChat_Id,
  setIsExternalFilter,
  setUserData,
} from "../../../services/store/slice/ChatSlice";
import { useDispatch, useSelector } from "react-redux";
import Notification from "./Notification";
import { resetChatState } from "../../../services/store/slice/ChatSlice";
import EmailIcon from "@mui/icons-material/Email";
import taskIcon from "../../../../assets/icons/tasksIcon.svg";
import {
  ContactEmergencyRounded,
  ContactEmergencySharp,
  Contacts,
  SignalWifiOff,
} from "@mui/icons-material";
import { useTwilio } from "../../../services/context/TwilioContext";
import ChatNav from "./ChatNav";
import { setIsLogOutModalOpen } from "../../../services/store/slice/NotificationSlice";
import SignoutModal from "./SignoutModal";
import { NetworkContext } from "../../../services/context/NetworkContext";
import { setExternalCallAccess } from "../../../services/store/slice/CallSlice";
// import ticket from "../../../../assets/icons/ticket.svg";
const menuItems = [
  // {
  //   name: "Admin Panel",
  //   to: "/Admin",
  //   icon: <DashboardRoundedIcon fontSize="small" />,
  //   // filledIcon: <DashboardRoundedIcon sx={{ color: "#085F99" }} />,
  //   label: "Admin",
  // },
  {
    name: "Chats",
    to: "/chats",
    icon: <ChatRoundedIcon fontSize="small" />,
    // filledIcon: <ChatRoundedIcon sx={{ color: "#085F99" }} />,
    label: "Chats",
  },
  // {
  //   name: "Meetings",
  //   to: "/meetings",
  //   icon: <VideocamOutlinedIcon fontSize="small" />,
  //   // filledIcon: <VideocamOutlinedIcon sx={{ color: "#085F99" }} />,
  //   label: "Meetings",
  // },
  {
    name: "contacts",
    to: "/contacts",
    icon: <ContactEmergencyRounded fontSize="small" />,
    // filledIcon: <VideocamOutlinedIcon sx={{ color: "#085F99" }} />,
    label: "Contacts",
  },
  {
    name: "emails",
    to: "/emails",
    icon: <EmailIcon fontSize="small" />,
    // filledIcon: <VideocamOutlinedIcon sx={{ color: "#085F99" }} />,
    label: "Emails",
  },
  {
    name: "tasks",
    to: "/tasks",
    icon: (
      <Box
        sx={{ width: "18px", height: "18px" }}
        component="img"
        src={taskIcon}
        alt=""
      />
    ),
    label: "Tasks",
  },
  // {
  //   name: "tickets",
  //   to: "/tickets",
  //   icon: <img src={ticket} style={{ width: "20px" }} />,
  //   // filledIcon: <VideocamOutlinedIcon sx={{ color: "#085F99" }} />,
  //   label: "Tickets",
  // },
];
const settings = [
  {
    // to: "/Admin",
    icon: <SettingsOutlinedIcon fontSize="small" />,
    // filledIcon: <DashboardRoundedIcon sx={{ color: "#085F99" }} />,
    label: "Settings",
  },
];

function NavigationBar() {
  // for Modal States
  const dispatch = useDispatch();
  const [openLogOutModal, setOpenLogOutModal] = useState(false);
  const {
    setCallStatus,
    groupRoom,
    setActiveGroupRooms,
    setIsGroupCallRingtone,
    setReconnectingParticipants,
  } = useTwilio();
  const { audioCallStart } = useSelector((state) => state.call);
  const { isLogOutModalOpen } = useSelector((state) => state.notification);
  const [showProfileHead, setShowProfileHead] = useState(false);
  const [showProfileInfo, setShowProfileInfo] = useState(false);
  // Call provider setting (Twilio vs RingCentral). SYSTEM-WIDE: the source of
  // truth is the DB (SystemSettings.CallProvider); localStorage is just a cache.
  // Changing it here persists to the DB and broadcasts to all clients.
  const [openSettings, setOpenSettings] = useState(false);
  const [callProvider, setCallProviderState] = useState(() =>
    getLocalCallProvider(),
  );
  const selectCallProvider = async (provider) => {
    setCallProviderState(provider); // optimistic
    const saved = await changeCallProvider(provider, getUserId);
    if (!saved) {
      // Revert on failure so the UI doesn't lie about the saved value.
      setCallProviderState(getLocalCallProvider());
    }
  };
  // Load the system provider on mount, and keep the toggle in sync when it is
  // changed elsewhere (another client / SignalR broadcast).
  useEffect(() => {
    syncCallProviderFromServer().then((p) => setCallProviderState(p));
    const onChange = (e) =>
      setCallProviderState(e?.detail || getLocalCallProvider());
    window.addEventListener(CALL_PROVIDER_EVENT, onChange);
    return () => window.removeEventListener(CALL_PROVIDER_EVENT, onChange);
  }, []);
  const { internetAvailable } = useContext(NetworkContext);
  // get userId from Local storage
  const getUserId = localStorage.getItem("user_id");
  const navigate = useNavigate();
  const location = useLocation();
  const { userData } = useSelector((state) => state.chat);
  const { isExternalFilter } = useSelector((state) => state.chat);

  // api get data by id
  const getData = useCallback(async (data) => {
    try {
      const response = await getUsersById(data);
      if (response?.status) {
        dispatch(setUserData(response?.data?.result || []));
        const { firstName, lastName } = response?.data?.result[0];
        const fullName = `${firstName} ${lastName}`;
        localStorage.setItem("username", fullName);
        dispatch(
          setExternalCallAccess(
            response?.data?.result?.[0]?.isExternalCallAllowed
          )
        );
        localStorage.setItem(
          "externalCallAllowed",
          response?.data?.result?.[0]?.isExternalCallAllowed
        );
      }
    } catch (err) {
      console.warn(err);
      dispatch(setUserData([]));
    }
  });

  useEffect(() => {
    if (getUserId) {
      getData(getUserId);
    }
  }, []);
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        getData(getUserId);
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  // Listen for the custom event and refresh data when triggered
  useEffect(() => {
    const handleUserDataRefresh = () => {
      if (getUserId) {
        getData(getUserId);
      }
    };
    window.addEventListener("refreshUserData", handleUserDataRefresh);
    return () => {
      window.removeEventListener("refreshUserData", handleUserDataRefresh);
    };
  }, [getUserId]);

  useEffect(() => {
    initializeSignalRConnection(
      setCallStatus,
      setActiveGroupRooms,
      setIsGroupCallRingtone,
      setReconnectingParticipants
    );
  }, []);

  useEffect(() => {
    if (location.pathname != "/chats" && isExternalFilter) {
      dispatch(setIsExternalFilter(false));
    }
  }, [location.pathname, isExternalFilter]);

  // start
  const userRoles = JSON.parse(localStorage.getItem("user_roles"));
  // Check if userRoles is valid and not empty
  const hasAdminRole =
    Array.isArray(userRoles) &&
    userRoles.some((ur) => ur.roleName.toLowerCase() === "admin");
  const filteredMenuItems = menuItems.filter((item) => {
    // Filter out "Admin" if the user does not have the "Admin" role
    if (item.label === "Admin" && !hasAdminRole) {
      return false;
    }
    return true;
  });
  return (
    <>
      {/* {isMobile ? (
        <>
          <ChatNav />
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              width: "100%",
              overflow: "auto",
            }}
          >
            <Outlet />
          </Box>
        </>
      ) : ( */}
      {!internetAvailable && (
        <Box
          sx={{
            width: "100%",
            height: "25px",
            display:
              groupRoom !== null || audioCallStart === true ? "none" : "flex",
            alignItems: "center",
            justifyContent: "start",
            backgroundColor: "#F5F5F5",
            pl: 17,
            color: "red",
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 10,
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <SignalWifiOff sx={{ fontSize: 20, mr: 1 }} />
          <Typography sx={{ fontSize: "16px" }}>
            No Internet Connection!
          </Typography>
        </Box>
      )}
      {!internetAvailable && (
        <Box
          sx={{
            width: "100%",
            height: "100vh",
            display:
              groupRoom !== null || audioCallStart === true ? "flex" : "none",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(8px)",
            WebkitBackdropFilter: "blur(8px)",
            pl: 0,
            color: "white",
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 9999,
            textAlign: "center",
            padding: 2,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontWeight: "bold",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
            }}
          >
            <SignalWifiOff sx={{ fontSize: 20 }} />
            Hold on
          </Typography>
          <Typography sx={{ fontSize: "16px" }}>
            Looks like something went wrong. We're trying to get you back on the
            call.
          </Typography>
        </Box>
      )}

      <Box
        sx={{
          display: "flex",
          height: "100vh",
          overflowY: "hidden",
        }}
      >
        <CssBaseline />
        <Drawer
          variant="permanent"
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              border: "none",
              // background:
              //   "radial-gradient(circle at 10% 20%, rgb(0, 102, 161) 0%, rgb(0, 68, 108) 90.1%)",
              // background: "#0D406F",
              background: "#085F99",
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
            },
          }}
        >
          {/* <Toolbar /> */}
          <Box
            sx={{
              overflow: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              <img
                src={AppLogo}
                style={{
                  height: "60px",
                  width: "75px",
                }}
                alt={`applogo`}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                p: 1,
                pt: 3,
              }}
            >
              {filteredMenuItems?.map((item, index) => (
                <Tooltip
                  title={item.name}
                  key={index}
                  placement="right-start"
                  arrow
                >
                  <Box
                    component={NavLink}
                    onClick={() => {
                      localStorage.removeItem("chatId");
                      dispatch(setChat_Id(null));
                    }}
                    to={item.to}
                    sx={{
                      ...listItemStyles,
                      p: 1,
                      "&:hover": {
                        borderRadius: "7px",
                        background: "#0D4273",
                      },
                      "&.active": {
                        background: "#0D4273",
                        color: "#fff",
                        borderRadius: "7px",
                      },
                    }}
                  >
                    {item.icon}
                  </Box>
                </Tooltip>
              ))}
            </Box>
          </Box>
          {/* profile box */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              p: 1,
            }}
          >
            <Box
              // onMouseEnter={() => setShowProfileInfo(true)}
              // onMouseLeave={() => setShowProfileInfo(false)}
              sx={{
                ...listItemStyles,
                p: 1,
                "&:hover": {
                  borderRadius: "7px",
                  background: "#0D4273",
                },
                "&.active": {
                  background: "#0D4273",
                  borderRadius: "7px",
                },
                display: "flex",
                flexDirection: "column",
              }}
            >
              <StyledBadge
                onMouseEnter={() => setShowProfileInfo(true)}
                onMouseLeave={() => setShowProfileInfo(false)}
                overlap="circular"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                variant="dot"
              >
                <Avatar
                  sx={{
                    bgcolor: "#085F99",
                    width: 30,
                    height: 30,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    // handleClose();
                    navigate("/admin/info");
                    setShowProfileHead(true);
                  }}
                  src={`${s.baseUrl}${userData[0]?.profilePicPath}`}
                />
              </StyledBadge>

              <Typography
                title={`${userData[0]?.firstName} ${userData[0]?.lastName}`}
                sx={{ fontSize: "10px", fontFamily: "Poppins" }}
              >
                {" "}
                {userData[0]?.firstName}
                {/* {userData[0]?.lastName || "Name"} */}
              </Typography>
            </Box>
            {/* settings - admin only */}
            {hasAdminRole && (
              <Tooltip title="Settings" arrow placement="right-start">
                <Box
                  sx={{
                    ...listItemStyles,
                    p: 1,
                    cursor: "pointer",
                    "&:hover": {
                      borderRadius: "7px",
                      background: "#0D4273",
                    },
                  }}
                  onClick={() => setOpenSettings(true)}
                >
                  <SettingsOutlinedIcon fontSize="small" />
                </Box>
              </Tooltip>
            )}
            {/* logout  */}
            <Tooltip title="Logout" arrow placement="right-start">
              <Box
                sx={{
                  ...listItemStyles,
                  p: 1,
                  cursor: "pointer",
                  "&:hover": {
                    borderRadius: "7px",

                    background: "#0D4273",
                  },
                  "&.active": {
                    // backgroundColor: "#1b2631",
                    background: "#085F99",
                    borderRadius: "7px",
                  },
                }}
              >
                <LogoutIcon
                  fontSize="small"
                  onClick={() => {
                    dispatch(setIsLogOutModalOpen(true));
                  }}
                />
              </Box>
            </Tooltip>
          </Box>
        </Drawer>
        {/* Settings dialog — call provider selector */}
        <Dialog
          open={openSettings}
          onClose={() => setOpenSettings(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle sx={{ fontWeight: 700, fontSize: "16px" }}>
            Settings
          </DialogTitle>
          <DialogContent>
            <Typography sx={{ fontSize: "13px", fontWeight: 600, mb: 1 }}>
              Calling provider
            </Typography>
            <Typography sx={{ fontSize: "11px", color: "#5e6b7a", mb: 1.5 }}>
              Choose how calls are placed. This is saved and used for all calls
              until you change it.
            </Typography>
            <Box
              sx={{
                display: "flex",
                border: "1px solid #B7B7B763",
                borderRadius: "999px",
                overflow: "hidden",
                backgroundColor: "#f8fbff",
              }}
            >
              {["RingCentral", "Twilio"].map((provider) => (
                <Button
                  key={provider}
                  fullWidth
                  disableElevation
                  onClick={() => selectCallProvider(provider)}
                  sx={{
                    borderRadius: 0,
                    minHeight: "34px",
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: "12px",
                    color: callProvider === provider ? "#fff" : "#5e6b7a",
                    backgroundColor:
                      callProvider === provider ? "#085F99" : "transparent",
                    "&:hover": {
                      backgroundColor:
                        callProvider === provider
                          ? "#074b78"
                          : "rgba(8, 95, 153, 0.08)",
                    },
                  }}
                >
                  {provider === "RingCentral" ? "Ring Central" : "Twilio"}
                </Button>
              ))}
            </Box>
          </DialogContent>
        </Dialog>
        {/* profile card */}
        {showProfileInfo && (
          <Grid
            container
            sx={{
              height: "150px",
              width: "250px",
              backgroundColor: "background.paper",
              borderRadius: "5px",
              position: "absolute",
              bottom: 10,
              left: 50,
              zIndex: 1000000,
              border: "1px solid lightgray",
            }}
          >
            <Grid
              item
              xs={12}
              xl={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Box display={"flex"}>
                {userData[0]?.profilePicPath &&
                userData[0]?.profilePicPath != "null" ? (
                  <Box
                    component={"img"}
                    width={"80px"}
                    height={"80px"}
                    borderRadius={"50%"}
                    objectFit={"cover"}
                    src={`${s.baseUrl}${
                      userData[0]?.profilePicPath === "null"
                        ? null
                        : userData[0]?.profilePicPath
                    }`}
                    alt="Profile"
                    sx={{ cursor: "pointer" }}
                  />
                ) : (
                  <Avatar
                    sx={{
                      bgcolor: "#085F99",
                      width: 40,
                      height: 40,
                      cursor: "pointer",
                    }}
                  >
                    <PersonIcon />
                  </Avatar>
                )}
              </Box>
              {/* profile */}
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: "bold",
                  fontFamily: "Poppins",
                }}
              >
                {(userData[0]?.firstName ?? "-") +
                  " " +
                  (userData[0]?.lastName ?? "-")}
              </Typography>
              <Typography
                variant="subtitle2"
                sx={{
                  fontFamily: "Poppins",
                }}
              >
                {userData[0]?.email || "email@example.com"}
              </Typography>
              <Typography
                variant="subtitle2"
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "10px",
                  borderRadius: "20px",
                  background: "green",
                  color: "white",
                  position: "absolute",
                  top: 5,
                  left: 5,
                  pl: 1,
                  pr: 1,
                  pt: 0.5,
                  pb: 0.5,
                }}
              >
                {userData[0]?.isActive ? "Active" : "Inactive"}
              </Typography>
              <Typography
                variant="subtitle2"
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "10px",
                  borderRadius: "20px",
                  background: "lightgray",
                  color: "#333",
                  position: "absolute",
                  top: 5,
                  right: 5,
                  pl: 1,
                  pr: 1,
                  pt: 0.5,
                  pb: 0.5,
                }}
              >
                {userData[0]?.roles[0]?.roleName}
              </Typography>
            </Grid>
          </Grid>
        )}

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            width: "100%",
            overflow: "auto",
          }}
        >
          <Outlet />
        </Box>
        <Notification />
      </Box>
      {isLogOutModalOpen && <SignoutModal />}
    </>
  );
}

export default NavigationBar;

const drawerWidth = 80;
const listItemStyles = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "white",
  textDecoration: "none",
};
const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));
